import React from 'react'

import Button from '@mui/material/Button'
import List from '@mui/material/List'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { Drawer, useBudgetsStore, useCategoryStore, useGlobalCopyStore } from '../../../common'

import { RecalculateBudgetRow } from './RecalculateBudgetRow'

interface RecalculateBudgetsProps {
  onRecalculateBudgets?: () => void
}

export const RecalculateBudgets = ({ onRecalculateBudgets }: RecalculateBudgetsProps) => {
  const { budgets: copy, common: commonCopy } = useGlobalCopyStore()
  const { spendCategories } = useCategoryStore()
  const { recalculateBudgets, setAlert } = useBudgetsStore()

  const [isOpen, setIsOpen] = React.useState(false)

  const newBudgetCategories = spendCategories.filter((category) => category.totalAverageAmount > 0)

  const handlePrimaryClick = async () => {
    await recalculateBudgets(newBudgetCategories)

    setIsOpen(false)
    setAlert({ msg: copy.alert_recalculated_budgets, severity: 'success' })
    onRecalculateBudgets?.()
  }

  return (
    <React.Fragment>
      <Button onClick={() => setIsOpen(true)} sx={{ mt: 24, mx: 24 }} variant="text">
        {copy.recalculate_button}
      </Button>

      <Text sx={{ mx: 24, my: 16, textAlign: 'center' }} variant="subtitle1">
        {copy.recalculate_help}
      </Text>
      <Drawer
        ariaLabelClose={commonCopy.close_aria}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onPrimaryAction={handlePrimaryClick}
        title={copy.recalculate_title}
      >
        <Stack>
          <Stack mx={24} my={16}>
            <Text bold={true} variant="body1">
              {copy.recalculate_description_top}
            </Text>
            <Text variant="subtitle2">{copy.recalculate_description_bottom}</Text>
          </Stack>
          <Box bgcolor="background.paper">
            <List>
              {newBudgetCategories.map((category) => (
                <RecalculateBudgetRow category={category} key={category.guid} />
              ))}
            </List>
          </Box>
        </Stack>
      </Drawer>
    </React.Fragment>
  )
}
